export default __webpack_public_path__ + "static/media/NYC_StandAlone.d88dcca8.svg";